import { render, staticRenderFns } from "./PoActivityRecordListForHomework.vue?vue&type=template&id=65ca859b"
import script from "./PoActivityRecordListForHomework.vue?vue&type=script&lang=js"
export * from "./PoActivityRecordListForHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports